import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/DesignSystem/Button';
import { AgroOverviewLocation } from 'types/Meteorology/Agro/Overview/Dashboard';
import {
  selectAgroOverviewTableSearch,
  selectAgroOverviewTableSortBy,
  selectAgroOverviewTableSortDirection,
} from 'redux/reducers/meteorologyAgroOverviewDashboardReducer';
import { filterAndSortLocations } from 'helper/Meteorology/Agro/Overview/locationsTable';
import { exportLocationsCsv } from 'helper/Meteorology/Agro/Overview/exportCsv';

/**
 * Exporta a tabela "Localidades monitoradas" como CSV (dialeto Excel pt-BR),
 * com a MESMA ordenação e busca exibidas na tela — export WYSIWYG.
 * Contrato: ADENDO-2 de docs/contracts/agro-overview.md (BE).
 */
export default function ExportButton({ locations }: { locations: AgroOverviewLocation[] }) {
  const search = useSelector(selectAgroOverviewTableSearch);
  const sortBy = useSelector(selectAgroOverviewTableSortBy);
  const sortDirection = useSelector(selectAgroOverviewTableSortDirection);

  const rows = useMemo(
    () => filterAndSortLocations(locations, search, sortBy, sortDirection),
    [locations, search, sortBy, sortDirection],
  );

  return (
    <Button
      type="secondary"
      icon="download"
      disabled={rows.length === 0}
      onClick={() => exportLocationsCsv(rows)}
    >
      Exportar relatório
    </Button>
  );
}
